export const OAUTH2_CLIENT_ID = 'e900b041-dcd7-4bca-a1d8-4a57062bc778';
export const OAUTH2_CLIENT_SECRET =
    'KA7dXOH5Cj7VAi125g1zUYJY_k-RVnoGdD-_sIhYgSBvIGiiiRDN96Wzn7';

const OAUTH2_STORAGE_KEY = 'oAuth2Object';

export const setOAuth2AuthenticationExpires = (expiresIn: number) =>
    Date.now() + (expiresIn - 10) * 1000;

export const getOAuth2Store = () => {
    try {
        const data = localStorage.getItem(OAUTH2_STORAGE_KEY);
        const parsedData = data ? JSON.parse(data) : null;
        if (
            parsedData &&
            typeof parsedData.accessToken === 'string' &&
            typeof parsedData.refreshToken === 'string' &&
            typeof parsedData.expires === 'number'
        ) {
            return parsedData;
        }
        if (parsedData !== null) {
            console.warn('Invalid OAuth2 store object:', parsedData);
        }
        return null;
    } catch (e) {
        console.error('Error reading OAuth2 store:', e);
        return null;
    }
};

export const setOAuth2Store = (
    accessToken: string,
    refreshToken: string,
    expiresIn: number,
    tokenType = 'Bearer',
) => {
    localStorage.setItem(
        OAUTH2_STORAGE_KEY,
        JSON.stringify({
            accessToken,
            refreshToken,
            expires: setOAuth2AuthenticationExpires(expiresIn),
            tokenType,
        }),
    );
    return getOAuth2Store();
};

export const removeOAuth2Store = () => {
    try {
        if (typeof window !== 'undefined' && window.localStorage) {
            localStorage.removeItem(OAUTH2_STORAGE_KEY);
        }
    } catch (e) {
        console.error('Error removing OAuth2 store:', e);
    }
};
